<div class="pr-input-container">
  @if (!!label) {
    <span class="pr-input-label"
      >{{ label }}
      @if (
        required ||
        (control &&
          control.control &&
          control.control.validator &&
          control.control.validator({}) &&
          control.control.validator({}).required)
      ) {
        <em>
          @if (!labelFinishWithSpace()) {
            <span>&#160;</span>
          }
          *</em
        >
      }
    </span>
  }
  <span
    class="pr-input-container-control"
    [ngClass]="{ 'is-invalid': derrors && control?.errors, readonly: readonly }"
  >
    <ng-content></ng-content>
    @if (suffix) {
      <span class="pr-input-suffix">{{ suffix }}</span>
    }
    <pr-errors [derrors]="derrors" [control]="control"></pr-errors>
  </span>
</div>
